import React, { Component } from "react";
import ReactDOM from "react-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  CustomizedXAxisTickTime,
  CustomizedYAxisTick,
  selectFormat,
} from "./../Utils/Utils.js";

const COLORS = {
  youtube: "#FCD23A",
  " facebook": "#16C8DE",
  twitter: "#3b5998",
  instagram: "#16DE85",
  organic: "#16DE85",
  search: "#F7A4D2",
  other: "#FCD23A",
  date: "#333333",
};

const createLabel = (key, payload) => (
  <div className="value" key={key}>
    <span className="key" style={{ color: COLORS[key] }}>
      {key}
    </span>{" "}
    :{selectFormat("percentage", payload[key])}
  </div>
);

class CustomToolTip extends Component {
  showLabels = (payload) => {
    let labels = [];

    if (payload) {
      Object.keys(payload).forEach((key) => {
        if (key === "date") {
          return (labels[0] = createLabel(key, payload));
        } else if (key === "youtube") {
          return (labels[1] = createLabel(key, payload));
        } else if (key === "facebook") {
          return (labels[2] = createLabel(key, payload));
        } else if (key === "twitter") {
          return (labels[3] = createLabel(key, payload));
        } else if (key === "organic") {
          return (labels[4] = createLabel(key, payload));
        } else if (key === "search") {
          return (labels[4] = createLabel(key, payload));
        } else if (key === "other") {
          return (labels[4] = createLabel(key, payload));
        } else {
        }
      });
    }
    return labels;
  };

  render() {
    const { active } = this.props;

    if (active) {
      const { payload } = this.props;
      if (payload && payload.length > 0) {
        return (
          <div className="custom-tooltip">
            {this.showLabels(payload[0].payload)}
          </div>
        );
      }
    }

    return null;
  }
}

class ViewersLineGraphs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      networks: [],
      data: [],
    };
  }

  toggleGraphValues = (property, data) => {
    let new_data = JSON.parse(JSON.stringify(data));

    new_data.forEach(function (entry, index) {
      Object.keys(entry).forEach(function () {
        property.forEach(function (name) {
          if (entry[name] != null) {
            entry[name] = null;
          }
        });
      });
    });

    return new_data;
  };

  clickGraphLegend = (event) => {
    const value = event.value;
    let arr = this.state.networks;
    const data = this.props.data.data;

    // Legends
    const node = ReactDOM.findDOMNode(this.refs.social_graph);
    const list_elements = node.querySelectorAll(".recharts-legend-item");

    // Select clicked legend
    for (let i = 0; i < list_elements.length; i++) {
      if (list_elements[i].textContent === value) {
        list_elements[i]
          .querySelector(".recharts-symbols")
          .classList.toggle("legend-off");
      }
    }

    // create an array of networks
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    } else {
      arr.splice(arr.indexOf(value), 1);
    }

    // toggle network values
    let new_data = this.toggleGraphValues(arr, data);
    this.setState({ networks: arr, data: new_data });
  };

  handleLineClick = () => {};

  renderGraph = (data) => {
    // Remove Twitter
    // data.map((a,index) => {
    //   return delete a.twitter;
    // });

    return (
      <ResponsiveContainer height={250}>
        <LineChart
          height={250}
          data={data}
          margin={{
            top: 20,
            right: 0,
            left: 5,
            bottom: 0,
          }}
          ref="social_graph"
        >
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
            scale="point"
            tick={<CustomizedXAxisTickTime />}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            mirror={true}
            tick={<CustomizedYAxisTick />}
          />

          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={<CustomToolTip />}
          />

          <CartesianGrid
            stroke="#FEE5DE"
            strokeDasharray="3 3"
            vertical={false}
          />

          <Legend
            verticalAlign="top"
            align="left"
            iconType="square"
            iconSize={15}
            height={65}
            onClick={this.clickGraphLegend}
          />

          <Line
            type="monotone"
            activeDot={{ onClick: this.handleLineClick }}
            dataKey="Video Impressions"
            stroke="#16C8DE"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            activeDot={{ onClick: this.handleLineClick }}
            dataKey="3s View"
            stroke="#3b5998"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            activeDot={{ onClick: this.handleLineClick }}
            dataKey="10s View"
            stroke="#16DE85"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            activeDot={{ onClick: this.handleLineClick }}
            dataKey="Completions"
            stroke="#F7A4D2"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            activeDot={{ onClick: this.handleLineClick }}
            dataKey="other"
            stroke="#FCD23A"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  };

  render() {
    let graphData = this.props.data;

    if (this.state.networks.length) {
      graphData = this.state.data;
    } else {
      graphData = graphData.data;
    }

    return (
      <div className="col-12">
        <div className="widget">
          <header className="widget__header">
            <h5 className="widget__title">Views By Network</h5>
          </header>
          <div className="row">
            <div className="col-12">
              {/*
              <div className="row">
                <div className="col">
                  <Metric {...this.props.data.value}/>
                </div>
              </div>
              */}
              {this.renderGraph(graphData)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewersLineGraphs;
